import { render, staticRenderFns } from "./MaterialExplanation.vue?vue&type=template&id=a184460e&"
import script from "./MaterialExplanation.vue?vue&type=script&lang=ts&"
export * from "./MaterialExplanation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports